import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import {
  buildListingUrl,
  buildListingFiltersUrl,
  buildSeoDataUrl,
  type PlpListingRequestArgs,
} from '../utils/plpListingRequest';

const plpApiSlice = createApiSlice({
  clientId: 'plpApi',
  tagTypes: ['PLP'],
  endpoints: {
    getListing: {
      url: (args: unknown) => buildListingUrl((args || {}) as PlpListingRequestArgs),
      method: 'GET',
      keepUnusedDataFor: 120,
      providesTags: ['PLP'],
    },
    getListingFilters: {
      url: (args: unknown) => buildListingFiltersUrl((args || {}) as PlpListingRequestArgs),
      method: 'GET',
      keepUnusedDataFor: 0,
    },
    getSeoData: {
      url: (args: unknown) => buildSeoDataUrl((args || {}) as PlpListingRequestArgs),
      method: 'GET',
      keepUnusedDataFor: 120,
      providesTags: ['PLP'],
    },
    /** @deprecated Use getListing — kept for SSR migration references */
    getPlp: {
      url: (args: unknown) => buildListingUrl((args || {}) as PlpListingRequestArgs),
      method: 'GET',
      keepUnusedDataFor: 120,
      providesTags: ['PLP'],
    },
  },
});

export const plpApi = plpApiSlice.queryClient;
export const plpApiRedux = plpApiSlice.queryClient as ReduxQueryClient;

export type { PlpListingRequestArgs };
